import { MedicalCategoryGrid } from '@/features/medical-category-display';

const MedicalCategorySection = () => {
  return (
    <>
      <div className='mb-[12px] flex px-[24px] sm:mb-[24px] md:px-[0px]'>
        <div className='typography-ui-20sb sm:typography-ui-22sb text-center text-gray-800'>비대면 진료 시작하기</div>
      </div>
      <div className='flex justify-center'>
        <MedicalCategoryGrid />
      </div>
    </>
  );
};

export default MedicalCategorySection;
